'use client'

import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Bell, CalendarDays, LayoutGrid } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useMesero } from '@/modules/mesero/MeseroProvider'

export function MeseroBottomNav({ alertsCount }: { alertsCount: number }) {
  const location = useLocation()
  const navigate = useNavigate()
  const { reservations } = useMesero()

  const scheduledCount = useMemo(() => {
    return (reservations ?? []).filter((r) => r.status === 'scheduled' && !r.tableId).length
  }, [reservations])

  const active = useMemo(() => {
    if (location.pathname.startsWith('/mesero/alertas')) return 'alertas'
    if (location.pathname.startsWith('/mesero/reservas')) return 'reservas'
    return 'mesas'
  }, [location.pathname])

  return (
    <div className="border-t border-white/10 bg-[#0f0f11] px-0 pt-2 pb-6 shrink-0">
      <div className="flex">
        <button
          type="button"
          onClick={() => navigate('/mesero/mesas')}
          className={cn('flex-1 flex flex-col items-center gap-1 py-2', active === 'mesas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}
        >
          <LayoutGrid className={cn('h-6 w-6', active === 'mesas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')} />
          <span className={cn('text-[10px] font-medium', active === 'mesas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}>Mesas</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/mesero/reservas')}
          className={cn('flex-1 flex flex-col items-center gap-1 py-2 relative', active === 'reservas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}
        >
          <CalendarDays className={cn('h-6 w-6', active === 'reservas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')} />
          {scheduledCount > 0 && (
            <span className="absolute top-1 right-[calc(50%-20px)] w-4 h-4 rounded-full bg-[#4d9fff] text-black text-[9px] font-semibold flex items-center justify-center border-2 border-[#0f0f11]">
              {Math.min(scheduledCount, 99)}
            </span>
          )}
          <span className={cn('text-[10px] font-medium', active === 'reservas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}>Reservas</span>
        </button>
        <button
          type="button"
          onClick={() => navigate('/mesero/alertas')}
          className={cn('flex-1 flex flex-col items-center gap-1 py-2 relative', active === 'alertas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}
        >
          <Bell className={cn('h-6 w-6', active === 'alertas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')} />
          {alertsCount > 0 && (
            <span className="absolute top-1 right-[calc(50%-20px)] w-4 h-4 rounded-full bg-[#00e5a0] text-black text-[9px] font-semibold flex items-center justify-center border-2 border-[#0f0f11]">
              {Math.min(alertsCount, 9)}
            </span>
          )}
          <span className={cn('text-[10px] font-medium', active === 'alertas' ? 'text-[#00e5a0]' : 'text-[#5a5a6a]')}>Alertas</span>
        </button>
      </div>
    </div>
  )
}

